import { CommissionLayout } from "./commission-layout";
import CommissionTransactionsPage from "./transactions";
import CommissionImportPageContent from "./import";
import CommissionMatchingPageContent from "./matching";
import CommissionDashboard from "./dashboard";
import CommissionRctiPageContent from "./rcti";

/**
 * Commission Dashboard route — renders analytics dashboard.
 * /commission/dashboard
 */
export function CommissionDashboardPage() {
  return (
    <CommissionLayout>
      <CommissionDashboard />
    </CommissionLayout>
  );
}

export function CommissionTransactionsWrapper() {
  return (
    <CommissionLayout>
      <CommissionTransactionsPage />
    </CommissionLayout>
  );
}

export function CommissionImportPage() {
  return (
    <CommissionLayout>
      <CommissionImportPageContent />
    </CommissionLayout>
  );
}

export function CommissionMatchingPage() {
  return (
    <CommissionLayout>
      <CommissionMatchingPageContent />
    </CommissionLayout>
  );
}

export function CommissionRctiPage() {
  return (
    <CommissionLayout>
      <CommissionRctiPageContent />
    </CommissionLayout>
  );
}

// Default export redirects to transactions (the primary view)
export default CommissionTransactionsWrapper;
